import getColor from "@insite/mobius/utilities/getColor";
import { TYPOGRAPHY } from "@store/theme/design";
import { css } from "styled-components";

export default {
    defaultProps: {
        typographyProps: null,
        color: null,
        iconProps: {
            src: "XCircle",
            size: 16,
            color: "inherit",
        },
        css: css`
            align-items: center;
            min-height: 0;
            max-width: none;
            background-color: ${getColor("common.accent")};
            color: ${getColor("common.accentContrast")};
            font-size: ${TYPOGRAPHY.size.smaller};
            line-height: ${TYPOGRAPHY.lineHeight.small};
            padding: 0.5em 0.75em;
            border-radius: 4px;
            word-break: break-all;

            button {
                min-width: 0;
                min-height: 0;
                background-color: transparent !important;
                padding: 0.2em;
                margin: -0.2em -0.3em -0.2em 0.4em;
                box-sizing: content-box;
                color: ${getColor("text.disabled")};
                border-radius: inherit;

                &:hover {
                    color: ${getColor("common.accentContrast")};
                }
            }
        `,
    },
};
